










import { Vue, Component, Prop } from 'vue-property-decorator';
import { BottomTabbar, Banner } from '@/components';
import * as config from './config';
import { getBaseinfo } from './api/index';
import { appShare, wxShareInfo } from '@/common/ts/common';

@Component({
  components: {
    BottomTabbar,
    Banner,
  },
})
export default class Home extends Vue {
  baseInfo: object = {};
  options = config.OPTHINES;
  created() {
    this.$addPv(373);
    getBaseinfo().then((res: any) => (this.baseInfo = res.data));
    // 新版分享方案
    appShare({
      title: `健康70年---重庆健康民生贡献力70品牌寻找与展示活动`,
      url: location.href,
      subtitle: '健康70年---重庆健康民生贡献力70品牌寻找与展示活动',
      classId: -1,
      id: -1,
      type: 3,
    });
    wxShareInfo({
      title: '健康70年---重庆健康民生贡献力70品牌寻找与展示活动',
      subtitle: '健康70年---重庆健康民生贡献力70品牌寻找与展示活动',
    });
  }
}
